import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavbarService } from '../navbar/services/navbar.service';
import { Subscription, Observable, of } from 'rxjs';
import { StepNavigatorService } from '../multi-step-navigator/components/step-navigator/services/step-navigator.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-offscreen-menu',
  templateUrl: './offscreen-menu.component.html',
  styleUrls: ['./offscreen-menu.component.scss']
})
export class OffScreenMenuComponent implements OnInit, OnDestroy {

  private showSuperiorButtons: boolean = undefined;
  private subscriptions: Subscription[] = [];
  constructor(
    private navbarService: NavbarService,
    private stepNavigatorService: StepNavigatorService) { }

  ngOnInit() { }

  closeMenu(): void {
    this.navbarService.closeMobileMenu();
  }

  /**
   * Define se pode mostrar ou não os menus de navegação
   */
  get shouldShowSuperiorButtons(): Observable<boolean> {
    if (this.showSuperiorButtons !== undefined) {
      return of(this.showSuperiorButtons);
    }

    return this.stepNavigatorService.mode().pipe(
      map((mode) => {
        this.showSuperiorButtons = (mode === 'single');
        return this.showSuperiorButtons;
      })) as Observable<boolean>;
  }

  /**
   * Avoid Memory leaks
   */
  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }
}
